// Profile search functionality for browse page
$(document).ready(function() {
  const searchInput = $('#profile-search');
  const searchSpinner = $('#search-spinner');
  let searchTimeout;

  // Distance filter elements
  const distanceSlider = $('#distance-slider');
  const distanceValue = $('#distance-value');
  const applyFiltersBtn = $('#apply-filters');
  const resetFiltersBtn = $('#reset-filters');
  const filterButton = $('#filter-button');
  const filterDropdown = $('#filter-dropdown');
  const filterBadge = $('#filter-badge');
  const filterCount = $('#filter-count');

  if (searchInput.length === 0) {
    return; // Exit if search input doesn't exist
  }

  // Initialize filter badge on page load
  function initializeFilterBadge() {
    if (distanceSlider.length) {
      const distance = parseInt(distanceSlider.val());
      if (distance !== 20) {
        filterBadge.removeClass('hidden');
        filterCount.text('1');
      }
    }
    updateFilterButtonState();
  }

  // Highlight the filter button while the dropdown is open or a non-default
  // distance is applied
  function updateFilterButtonState() {
    const open = !filterDropdown.hasClass('hidden');
    const distance = distanceSlider.length ? parseInt(distanceSlider.val()) : 20;
    filterButton.toggleClass('br-filter-active', open || distance !== 20);
  }

  function performSearch(includeDistance = true) {
    const searchQuery = searchInput.val();
    const profilesType = searchInput.data('profiles-type');
    const url = profilesType === 'nannies' ? '/browse/nannies' : '/browse/families';

    // Build data object
    const data = { q: searchQuery };

    // Include distance if specified
    if (includeDistance && distanceSlider.length) {
      data.distance = distanceSlider.val();
    }

    // Show spinner
    searchSpinner.removeClass('hidden');

    $.ajax({
      url: url,
      type: 'GET',
      data: data,
      dataType: 'script',
      success: function() {
        // Hide spinner after successful response
        searchSpinner.addClass('hidden');
      },
      error: function() {
        searchSpinner.addClass('hidden');
        console.error('Search request failed');
      }
    });
  }

  // Debounced search on keyup
  searchInput.on('keyup', function(e) {
    // Clear existing timeout
    clearTimeout(searchTimeout);

    // Don't search on special keys except Enter
    if (e.key === 'Enter') {
      performSearch();
      return;
    }

    // Ignore special keys
    if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt' ||
        e.key === 'Meta' || e.key === 'Tab' || e.key === 'Escape' ||
        e.key === 'ArrowUp' || e.key === 'ArrowDown' ||
        e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      return;
    }

    // Debounce - wait 300ms after user stops typing
    searchTimeout = setTimeout(function() {
      performSearch();
    }, 300);
  });

  // Clear search
  searchInput.on('search', function() {
    // This event fires when user clears the search box using the X
    if (this.value === '') {
      performSearch();
    }
  });

  // Update search box when profile type changes
  $('#location').on('change', function() {
    // Clear search when switching profile types
    searchInput.val('');
  });

  // Distance slider functionality
  if (distanceSlider.length) {
    // Update distance value display when slider moves
    distanceSlider.on('input', function() {
      distanceValue.text($(this).val());
    });

    // Update filter badge when distance changes from default
    function updateFilterBadge() {
      const distance = parseInt(distanceSlider.val());
      if (distance !== 20) {
        filterBadge.removeClass('hidden');
        filterCount.text('1');
      } else {
        filterBadge.addClass('hidden');
      }
    }

    // Toggle filter dropdown
    filterButton.on('click', function(e) {
      e.stopPropagation();
      filterDropdown.toggleClass('hidden');
      updateFilterButtonState();
    });

    // Close dropdown when clicking outside
    $(document).on('click', function(e) {
      if (!$(e.target).closest('#filter-dropdown, #filter-button').length) {
        filterDropdown.addClass('hidden');
        updateFilterButtonState();
      }
    });

    // Apply filters button
    applyFiltersBtn.on('click', function() {
      performSearch();
      filterDropdown.addClass('hidden');
      updateFilterBadge();
      updateFilterButtonState();
    });

    // Reset filters button
    resetFiltersBtn.on('click', function() {
      // Reset distance to default (20 miles)
      distanceSlider.val(20);
      distanceValue.text(20);

      // Clear search
      searchInput.val('');

      // Hide filter badge
      filterBadge.addClass('hidden');

      // Perform search with default values
      performSearch();
      filterDropdown.addClass('hidden');
      updateFilterButtonState();
    });

    // Apply filter when pressing Enter on the slider
    distanceSlider.on('keypress', function(e) {
      if (e.key === 'Enter') {
        performSearch();
        updateFilterBadge();
        updateFilterButtonState();
      }
    });

    // Initialize filter badge on page load
    initializeFilterBadge();
  }
});